import { connect } from 'react-redux'
import { goBack, replace } from 'react-router-redux'

import { getIssue, updateIssue } from '../../actions/issues'
import { loadIssueDescriptions } from '../../actions/issue-descriptions'

import { issueDescriptionSelector } from '../../selectors/issue-description-selectors'

import IssueForm from '../../components/issues/issue-form'

function mapStateToProps (state, ownProps) {
  const issue = state.issues[ownProps.params.issueId]

  if (!issue) return { loading: true }

  const location = state.locations[issue.location]
  const issueDescriptions = issueDescriptionSelector(state)

  return {
    issue,
    location,
    issueDescriptions,
    modalTitle: 'Edit Issue',
    submitButtonText: 'Update',
    initialValues: {
      status: issue.status,
      notes: issue.notes,
      areaId: issue.area,
      issueDescriptionId: issue.issueDescription
    }
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const { issueId, locationId } = ownProps.params

  dispatch(getIssue(issueId))
    .then(() => dispatch(loadIssueDescriptions()))

  return {
    onSubmit (data) {
      return dispatch(updateIssue(issueId, data))
        .then(action => action.error && Promise.reject({ _error: action.payload.errors[0] }))
        .then(action => dispatch(goBack()))
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueForm)



// WEBPACK FOOTER //
// ./src/containers/issues/issue-edit-container.js